import { Component, OnInit } from '@angular/core';
import { ServicerService } from '../../services/servicer.service';
import { IUser } from '../../../shared/models/identity.models';
import { GeneralService } from '../../../shared/services/general.service';

@Component({
  selector: 'app-servicer-list',
  templateUrl: './servicer-list.component.html',
  styleUrls: ['./servicer-list.component.css'],
})
export class ServicerListComponent implements OnInit {
  servicers: IUser[] = [];
  isLoading = false;

  // DevExtreme DataGrid configuration
  dataGridOptions: any = {
    dataSource: this.servicers,
    columns: [
      {
        dataField: 'fullName',
        caption: 'Name',
        allowResizing: true,
        sortIndex: 0,
        sortOrder: 'asc',
        calculateCellValue: (data: IUser) => `${data.firstName} ${data.lastName}`,
      },
      { dataField: 'role', caption: 'Role', allowResizing: true },
      {
        dataField: 'lastLogin',
        caption: 'Last Login',
        dataType: 'date',
        format: 'MM/dd/yyyy hh:mm a',
        allowResizing: true,
        calculateCellValue: (data: IUser) => (data.lastLogin ? new Date(data.lastLogin) : ''),
      },
    ],
    paging: { pageSize: 10 },
    searchPanel: {
      visible: true,
      width: 240,
      placeholder: 'Search...',
    },
    filterRow: { visible: true },
    headerFilter: { visible: true },
    columnAutoWidth: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    showBorders: true,
    rowAlternationEnabled: true,
  };

  constructor(
    private servicerService: ServicerService,
    private generalService: GeneralService
  ) { }

  ngOnInit(): void {
    this.loadServicers();
  }

  loadServicers(): void {
    this.isLoading = true;
    this.servicerService.getServicers().subscribe({
      next: (data) => {
        this.servicers = data;
        this.isLoading = false;
      },
      error: (err) => {
        this.generalService.showError(err);
        this.isLoading = false;
      },
    });
  }
}
